import { v4 as uuidv4 } from 'uuid';
export default {
  data() {
    return {
      colorTags: [
        { title: 'red', id: 1, color: '#1EAA6E' },
        { title: 'blue', id: 2, color: '#792554' },
        { title: 'orange', id: 3, color: '#D7712D' },
        { title: 'green', id: 4, color: '#E15858' },
      ],
      /*currentMission115TableHeader: [
                { text: "", value: "icon", align: "center", width: "50px" },
                { text: "آمبولانس", value: "ambulance", align: "center", width: "100px" },
                { text: "آدرس", value: "address", align: "center", width: "400px" },
                { text: "تشخیص احتمالی پرستار", value: "cheifComlaint", align: "center", width: "260px" },
                { text: "تلفن اصلی-پیگیری", value: "phone", align: "center", width: "220px" },
                { text: "وضعیت ماموریت", value: "missionStatus", align: "center", width: "220px" },
                { text: "وضعیت کد", value: "codeStatus", align: "center", width: "180px" },
                { text: "وضعیت آمبولانس", value: "ambulanceStatus", align: "center", width: "220px" },
                { text: "بیمارستان", value: "hospital", align: "center", width: "150px" },
                { text: "کاربر 115", value: "user", align: "center", width: "170px" },
            ],*/
      currentMission115TableHeader: [
        {
          text: 'کاربر 115',
          value: 'user',
          align: 'center',
          width: 170,
          sortable: false,
          isActive: true
        },
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: 150,
          sortable: false,
          isActive: true
        },
        {
          text: 'وضعیت آمبولانس',
          value: 'ambulanceStatus',
          align: 'center',
          width: 220,
          sortable: false,
          isActive: true
        },
        {
          text: 'وضعیت ماموریت',
          value: 'missionStatus',
          align: 'center',
          width: 200,
          sortable: false,
          isActive: true
        },
        {
          text: 'وضعیت کد',
          value: 'codeStatus',
          align: 'center',
          width: 180,
          sortable: false,
          isActive: true
        },
        {
          text: 'تلفن اصلی-پیگیری',
          value: 'phone',
          align: 'center',
          width: 220,
          sortable: false,
          isActive: true
        },
        {
          text: 'توضیح شکایت',
          value: 'chiefComplaintNote',
          align: 'right',
          width: 200,
          sortable: false,
          isActive: true
        },
        {
          text: 'شکایت اصلی',
          value: 'chiefComplaintText',
          align: 'right',
          width: 180,
          sortable: false,
          isActive: true
        },
        {
          text: 'تشخیص احتمالی پرستار',
          value: 'cheifComlaint',
          align: 'center',
          width: 260,
          sortable: false,
          isActive: true
        },
        {
          text: 'آدرس محل فوریت',
          value: 'address',
          align: 'center',
          width: 400,
          sortable: false,
          isActive: true
        },
        {
          text: 'کد عملیات',
          value: 'ambulance',
          align: 'center',
          width: 150,
          sortable: false,
          isActive: true
        },
        {
          text: '#',
          value: 'icon',
          align: 'center',
          width: 50,
          sortable: false,
          isActive: true
        },
      ].reverse(),
      uniqueId: '',
      callerId: '',
      destination: '',
      searchTitle: '',
      disabelConfirm: false,
      edit115MissionModal: false,
      missionId: null,
      missionPhoneId: null,
      showMenu: false,
      x: 0,
      y: 0,
      rightClickItems: [
        { title: 'جزئیات پرونده', icon: 'mdi-clipboard-text mdi-18px' },
        { title: 'تماس داخلی', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس خارجی', icon: 'mdi-phone-forward mdi-flip-h mdi-18px' },
        { title: 'تماس با کد', icon: 'mdi-phone mdi-flip-h mdi-18px' },
        { title: 'تماس با مددجو', icon: 'mdi-card-account-phone mdi-18px' },
      ],
      phoneId: null,
      rightClickData: null,
      closeOnContentClick: false,
      codePhoneNumbers: [],
      patientPhoneNumbers: [],
      iternalPhoneNumber: '',
      dbClickMouseInfo: null,
      externalPhoneNumber: '',
    };
  },
  methods: {
    addHandleMission: function () {
      let uniqeId = uuidv4();
      let user = this.$store.state.userModule.user;

      let objNewForm = {
        newForm: true,
        uniqueId: uniqeId.replaceAll("-", ""),
        callerId: "",
        destination: "",
        newFormType: "hand",
      }
      if (user.currentExtension) {
        objNewForm["destination"] = user.currentExtension.sipExtension;
      }

      this.$root.$refs.Home.newFormList.push(objNewForm);
      this.$root.$refs.Home.showDialogNewform = true
    },
    showEdit155MissionModal: function (value, data) {
      this.dbClickMouseInfo = value;
      this.missionPhoneId = data.item.id;
      this.missionId = data.item.missionId;
      this.phoneId = data.item.phoneId;
      this.edit115MissionModal = true;
    },
    rightClickHandler(e, data) {
      e.preventDefault();
      this.missionPhoneId = data.item.id;
      this.missionId = data.item.missionId;
      this.phoneId = data.item.phoneId;
      this.rightClickData = data.item;
      this.codePhoneNumbers = data.item.codePhoneNumber;
      this.patientPhoneNumbers = data.item.patiantPhoneNumbers;
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    rightClickAction: function (type, to) {
      this.showMenu = false;
      if (type == 'جزئیات پرونده') {
        this.edit115MissionModal = true;
      } else if (type == 'تماس با کد') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToCodeFunction(data);
        } else {
          this.snackText = 'برای ماموریت کد وجود ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type == 'تماس با مددجو') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToPatientFunction(data);
        }
      } else if (type == 'تماس داخلی') {
        if (this.iternalPhoneNumber) {
          const data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.iternalPhoneNumber,
          };
          this.callToInternalFunction(data);
          this.iternalPhoneNumber = '';
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === 'تماس خارجی') {
        if (this.externalPhoneNumber) {
          const data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.externalPhoneNumber,
          };
          this.callToCustomNumber(data);
          this.externalPhoneNumber = '';
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
    },
    setToopackForMission: function (toopack) {
      let id = '';
      if (this.missionPhoneId) {
        id = this.missionPhoneId.toString();
        id = id + this.missionId.toString();
      } else {
        id = this.missionId.toString();
      }
      localStorage.setItem(id, toopack.color);
      this.snackText = 'برچسب با موفقیت ثبت شد.';
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#4CAF50';
      this.snakIcon = 'mdi-check-circle';
      this.getData();
      this.showMenu = false;
    },
    removeTopack: function (id) {
      localStorage.removeItem(id);
      this.getListOfCurrentMissionFunction();
    },
  },
};
